import styled from '@emotion/styled';

export const Container = styled.div`
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    min-height: 100vh;
`;

export const Header = styled.div`
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    text-align: center;
`;

export const ShiftTimer = styled.div`
    font-size: 48px;
    font-weight: 700;
    color: #667eea;
    margin: 10px 0;
    cursor: pointer;
    user-select: none;
    transition: transform 0.2s;

    &:active {
        transform: scale(0.95);
    }
`;

export const TimerHint = styled.div`
    font-size: 12px;
    color: #999;
    margin-top: 5px;
`;

export const Section = styled.div`
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

export const Button = styled.button<{ variant?: 'primary' | 'success' | 'danger' }>`
    width: 100%;
    padding: 15px;
    background: ${props => {
        switch (props.variant) {
            case 'success':
                return 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)';
            case 'danger':
                return '#e53e3e';
            default:
                return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
        }
    }};
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    margin-bottom: 15px;
    min-height: 50px;

    &:active {
        transform: scale(0.98);
    }
`;

export const PromptText = styled.div`
    font-size: 16px;
    line-height: 1.5;
    color: #555;
    font-style: italic;
    min-height: 50px;
    display: flex;
    align-items: center;
    text-align: center;
`;

export const CategoriesGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 20px;
`;

export const CategoryButton = styled.button<{ selected?: boolean }>`
    padding: 15px;
    background: ${props => props.selected ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white'};
    color: ${props => props.selected ? 'white' : 'inherit'};
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    min-height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;

    &:active {
        transform: scale(0.95);
    }
`;

export const CategoryIcon = styled.span`
    font-size: 24px;
`;

export const TextArea = styled.textarea`
    width: 100%;
    min-height: 120px;
    padding: 15px;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    font-size: 16px;
    font-family: inherit;
    resize: vertical;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #667eea;
    }
`;

export const InsightsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
`;

export const InsightsTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #333;
`;

export const InsightsList = styled.div`
    max-height: 400px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
`;

export const InsightItem = styled.div`
    padding: 15px;
    background: #f7f7f7;
    border-radius: 12px;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
`;

export const InsightHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

export const InsightCategory = styled.span`
    display: inline-block;
    padding: 4px 10px;
    background: #667eea;
    color: white;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
`;

export const InsightTime = styled.span`
    font-size: 12px;
    color: #999;
`;

export const InsightContent = styled.div`
    font-size: 14px;
    line-height: 1.5;
    color: #555;
`;

export const EmptyState = styled.div`
    text-align: center;
    color: #999;
    padding: 40px 20px;
    font-style: italic;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
`; 